export const maxCadPerSessionPerMinute = 5;
export const cadWindowMs = 60_000;
export const cadHintMs = 10_000;
export const cadBusyMs = 15_000;

export const cadPendingLine = "Waiting for the device to report Ctrl+Alt+Del.";
export const cadHintLine = "No device result. Ctrl+Alt+Del may not have reached the screen.";
export const cadRecordFailedLine = "The request could not be recorded.";
export const cadNotVisibleLine = "The device sent Ctrl+Alt+Del but the secure screen did not appear.";
export const cadNotSentLine = "The device could not send Ctrl+Alt+Del.";

export type CadGate = "ready" | "channel" | "limited" | "sending";

export type CadResultError = "not_connected" | "rate_limited" | "not_sent" | "not_visible" | "sas_failed";

export function admitCad(sentAtMs: readonly number[], nowMs: number): boolean {
  return sentAtMs.filter((sentAt) => nowMs - sentAt < cadWindowMs).length < maxCadPerSessionPerMinute;
}

function cadStamp(at: Date, zone?: string): string {
  const parts = new Intl.DateTimeFormat("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
    timeZoneName: "short",
    timeZone: zone,
  }).formatToParts(at);
  const pick = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value ?? "";
  return `${pick("year")}-${pick("month")}-${pick("day")} ${pick("hour")}:${pick("minute")}:${pick("second")} ${pick("timeZoneName")}`.trim();
}

export function cadSentLine(at: Date, zone?: string): string {
  return `${cadStamp(at, zone)} Ctrl + Alt + Del sent`;
}

export function cadShownLine(at: Date, zone?: string): string {
  return `${cadStamp(at, zone)} Device reports the secure screen is showing. Check the screen.`;
}

export function cadStatusText(gate: CadGate, notice: string | null): string {
  const limit = `Ctrl+Alt+Del is limited to ${maxCadPerSessionPerMinute} times a minute.`;
  if (gate === "limited") return notice ? `${notice} ${limit}` : limit;
  if (notice) return notice;
  if (gate === "channel") return "Ctrl+Alt+Del waits for an open control channel.";
  if (gate === "sending") return "Sending Ctrl+Alt+Del.";
  return "";
}
